<template src='./calendarSummary.pug' lang='pug'></template>

<script>
import Vue from 'vue'
import ButtonPrimary from '../../buttons/buttonPrimary/ButtonPrimary'
import language from '../../../../build/language/index'
import DaySpanVuetify from 'dayspan-vuetify'
import CalendarDetailBox from './CalendarDetailBox'
import CalendarView from '../../calendarView/CalendarView'
import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import customSorter from '../../../utils/customSorter.js'

Vue.use(DaySpanVuetify)

export default {
  name: 'CalendarSummary',

  components: {
    ButtonPrimary,
    CalendarDetailBox,
    Datepicker,
    CalendarView
  },

  props: {
  },

  computed: {
    monthPickerLanguage () {
      return this.language.getDatePickerLanguageObject()
    },
    isLoadingData () {
      return this.isLoadingDataConcil || this.isLoadingCategories
    }
  },

  data () {
    return {
      isLoadingDataConcil: false,
      isLoadingCategories: false,
      language: language,
      selectedStartDate: new Date(),
      selectedEndDate: new Date(),
      selectedMonth: new Date(),
      conciliacaoData: [],
      categories: [],
      selectedCategory: {
        id: '-1',
        numero: '-1',
        nome: this.$t('inputTag.labels.todas')
      },
      categoryAll: {
        id: '-1',
        numero: '-1',
        nome: this.$t('inputTag.labels.todas')
      }
    }
  },

  methods: {
    validateClick (event) {
      if (event) {
        // event.day.date.toDate() get clicked day
        event.handled = true
        event.stopPropagation = true
      }
      return null
    },
    searchConciliationSummary () {
      if (this.selectedMonth) {
        let filter = {
          inicio: moment.utc(this.selectedMonth).startOf('month').startOf('day').valueOf(),
          fim: moment.utc(this.selectedMonth).endOf('month').endOf('day').valueOf(),
          idsContas: [],
          considerarContasInativas: false,
          idsEstabelecimentos: [],
          tipoMovimetacao: 'M',
          idsCategorias: [],
          idsPlanosConciliacao: [],
          situacoesConciliacao: ['A', 'C', 'M', 'D', 'N'],
          lang: 'pt'
        }
        this.isLoadingDataConcil = true
        let self = this
        return new Promise((resolve, reject) => {
          self.$store.dispatch('searchConciliationSummary', filter)
            .then((response) => {
              setTimeout(() => {
                self.handleResult(response.data.Body[0])
                self.isLoadingDataConcil = false
              }, 1000)
              resolve()
            }).catch((error) => {
              self.isLoadingDataConcil = false
              self.error = true
              self.msgError = error.body
              self.$root.$refs.notification.error('GENERAL')
              reject()
            })
        })
      }
    },
    handleResult (result) {
      let resumeList = []
      result.map(item => {
        resumeList.push({
          situacao: item.FlagSituacaoConciliacao,
          categoria: item.NomeCategoria,
          estabelecimento: item.Estabelecimento ? item.Estabelecimento : 'N/A',
          conta: item.Banco ? '(' + item.Banco + ') ' + item.Agencia + '/' + item.NrConta : this.$t('calendarioConciliacao.detalhe.movFinan'),
          totalExtrato: item.ValorExtratoBancario,
          totalMovFinan: item.ValorMovimentoFinanceiro,
          dataMin: moment.utc(item.DataMinimaLancamento).startOf('day').toDate(),
          dataMax: moment.utc(item.DataMaximaLancamento).endOf('day').toDate()
        })
      })
      this.conciliacaoData = resumeList
    },
    handleMonthChange (newDate) {
      this.selectedMonth = newDate
      this.searchConciliationSummary()
    },
    setStartDate (newStartDate) {
      this.selectedStartDate = moment.utc(newStartDate).toDate()
      this.selectedEndDate = moment.utc(newStartDate).toDate()
    },
    setEndDate (newEndDate) {
      this.selectedEndDate = moment.utc(newEndDate).toDate()
    },
    loadCategories () {
      this.isLoadingCategories = true
      this.$store.dispatch('getCategories', {
        url: '/categories/',
        flTipoCategoria: null,
        validarUso: false
      }).then((response) => {
        let catArray = []
        response.data.forEach(cat => {
          cat.label = cat.numero + ' - ' + cat.nome
          catArray.push(cat)
        })
        catArray.push(this.categoryAll)
        // arrayDottedSorter ordena o array baseado em valores do tipo '1.1.1'
        this.categories = customSorter.arrayDottedSorter(catArray, 'numero', 'asc')
        this.isLoadingCategories = false
      }).catch((error) => {
        this.$root.$refs.notification.error(error.data.message)
        this.isLoadingCategories = false
      })
    },
    setCategory (category) {
      this.selectedCategory = category && category.id ? category : this.categoryAll
    }
  },

  mounted () {
    this.loadCategories()
  }
}
</script>
<style>
@import '~dayspan-vuetify/dist/lib/dayspan-vuetify.min.css';

.ds-month .ds-week-header {
  display: -ms-flexbox;
  display: flex;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  height: 4vh;
}
.ds-day {
  flex: 1;
  width: 0;
  border-right: 1px solid #e0e0e0;
  border-bottom: 1px solid #e0e0e0;
  padding: 4px;
  overflow: hidden;
  height: 10vh;
}

.ds-gesture-container {
    width: 100%;
    height: 100%;
}

.ds-expand {
    width: 100%;
    height: 100%;
}

.ds-calendar {
    width: 100% !important;
    height: 100% !important;
    position: relative !important;
    padding: 0!important;
}

.ds-month-view {
    width: 100% !important;
    height: 100% !important;
}

.ds-month .ds-week-header {
    display: -ms-flexbox !important;
    display: flex !important;
    -webkit-user-select: none !important;
    -moz-user-select: none !important;
    -ms-user-select: none !important;
    user-select: none !important;
}

.ds-week {
    display: -ms-flexbox !important;
    display: flex !important;
    -ms-flex: 1 !important;
    flex: 1 !important;
}

.ds-out-calendar {
    color: #757575 !important;
}
.ds-day {
    -webkit-user-select: none !important;
    -moz-user-select: none !important;
    -ms-user-select: none !important;
    user-select: none !important;
}

.ds-day {
    -ms-flex: 1 !important;
    flex: 1 !important;
    width: 0 !important;
    border-right: 1px solid #e0e0e0 !important;
    border-bottom: 1px solid #e0e0e0 !important;
    padding: 4px !important;
    overflow: hidden !important;
}
.margin-box-15 {
  margin: 15px 15px 15px 0px;
}
</style>


// WEBPACK FOOTER //
// CalendarSummary.vue?5a0c2b14